import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})

@Injectable()
export class ContractService {
  getAllContractsUrl = environment.apiBaseUrl + "Contract/contracts";
  getSuppliersUrl = environment.apiBaseUrl + "Contract/getsuppliers";
  getMaterialsUrl = environment.apiBaseUrl + "Material/getmaterials";
  getQuantityUomsUrl = environment.apiBaseUrl + "Contract/getquantityuoms";
  getPriceUomsUrl = environment.apiBaseUrl + "Contract/getpriceuoms";
  getContractDetailsUrl = environment.apiBaseUrl + "Contract/getcontract";
  saveContractDetailsUrl = environment.apiBaseUrl + "Contract/updatecontract";
  getCustomerSitesUrl = environment.apiBaseUrl + "Site/getcustomersites";
  getCountriesUrl = environment.apiBaseUrl + "MasterData/getcountries";
  getProvincesUrl = environment.apiBaseUrl + "MasterData/getprovinces";
  getCitiesUrl = environment.apiBaseUrl + "MasterData/getcities";
  constructor(protected http: HttpClient) {
  }

  getAwardYears(): string[] {
    var startingYear = 1975;
    awardYears.push({ Year: null });
    var currentYear = (new Date()).getFullYear();
    for (let i = startingYear; i <= (currentYear + 5); i++) {
      awardYears.push({ Year: i });
    }
    return awardYears;
  }

  getContracts(): Observable<Contract[]> {
    let url = this.getAllContractsUrl;
    return this.http.get<Contract[]>(url);
  }

  getSuppliers(): Observable<string[]> {
    let url = this.getSuppliersUrl;
    return this.http.get<string[]>(url);
  }

  getMaterials(): Observable<Material[]> {
    let url = this.getMaterialsUrl;
    return this.http.get<Material[]>(url);
  }

  getQuantityUoms(): Observable<string[]> {
    let url = this.getQuantityUomsUrl;
    return this.http.get<string[]>(url);
  }

  getPriceUoms(): Observable<string[]> {
    let url = this.getPriceUomsUrl;
    return this.http.get<string[]>(url);
  }

  fetchContractDetails(id: number): Observable<Contract> {
    let url = this.getContractDetailsUrl;
    return this.http.get<Contract>(`${url}/${id}`);
  }

  getCountries(): Observable<Country[]> {
    let url = this.getCountriesUrl;
    return this.http.get<Country[]>(url);
  }

  getProvinces(): Observable<StateProvince[]> {
    let url = this.getProvincesUrl;
    return this.http.get<StateProvince[]>(url);
  }

  getCities(): Observable<City[]> {
    let url = this.getCitiesUrl;
    return this.http.get<City[]>(url);
  }

  getCustomerSites(): Observable<CustomerSite[]> {
    let url = this.getCustomerSitesUrl;
    return this.http.get<CustomerSite[]>(url);
  }

  saveContractDetails(data: Contract): Observable<boolean> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post<boolean>(this.saveContractDetailsUrl, JSON.stringify(data, null, 2), httpOptions);
  }

  getSupplyModes(): string[] {
    var supplyModes: string[] = [
      '',
      'Bulk',
      'Onsite',
      'Pipeline'
    ]

    return supplyModes;
  }
}

export class Contract {
  contractId: number;
  customer: string;
  supplier: string;
  material: string;
  materialId: number;
  quantity: number;
  quantityUom: string;
  siteId: number;
  price?: number;
  pricingUom?: string;
  supplyMode: string;
  awardYear: string;
  term: number;
  commenceYear: string;
  expireYear: string;
  annualRevenue?: number;
  notes?: string;
}

export class Material {
  materialId: number;
  materialName: string;
}

export class SupplyMode {
  Id: number;
  Name: string;
}

export class CustomerSite {
  siteId: number;
  customer: string;
  country: string;
  state: string;
  city: string;
}

export class Country {
  countryId: string;
  countryName: string;
}

export class StateProvince {
  provinceId: string;
  province: string;
  country: string;
}

export class City {
  city: string;
  province: string;
}

const awardYears = [];